/**
* @name APP chapala
* @autor ------------guesss---------@u-planner.com
* @description
* # name controller --> modulesListController
* # As Controller --> modulesListController
* brief comment controller shows the main view groupsList
*/

	export default class modulesListController {

 constructor($scope,groupsServices,$resource,$mdDialog,$timeout,ngNotify,UserInfoConstant,$state,$modal,$location,LOCAL_ENV_CONSTANT,modulePermissionSrv){

            var vm = this;
            this.$scope = $scope;
            this.$scope.grid=false
            this.services=modulePermissionSrv
            $scope.isDisabled=false

				$scope.UserInfoConstant = UserInfoConstant;
				$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
				if (details !== undefined) {
				//userinfo = details.user;
				 $scope.USER_ID=details.user.id;
				
				}
				});

          

    	     $scope.detailsRoles ={
    
				    enableFiltering: true,
				    columnDefs: [
				        {
				        field: 'ds_product_name',
				        displayName: 'producto',
				         width: '20%'
				        },
				        {
				        field: 'ds_name',
				        displayName: 'Modulo',
				       // width: '30%'
				        }
				        // ,
	           //          {
	           //          field: 'id_module',
	           //          displayName: 'Estado',
	           //          enableFiltering: false,
	           //          // width: '110',
	           //          enableSorting: false,
	           //          cellTemplate:`<div class="ui-grid-cell-contents text-center">
	           //                            <span class="text-center"  ng-model="row.entity.id_module"  
	           //                            ng-click="grid.appScope.selectAllItems(row.entity.ds_product_name,row.entity.ds_name,row.entity.id_module)">Edit<label class="md-check">
	           //                           <i class="green"></i></label></span></div>`

	           //          }
				       ]
            };

            
             int();

     
     
	           function int(){

			
			            	
			               modulePermissionSrv.services.getAllModules().$promise.then((dataReturn) => {

			                    if(dataReturn.data.lenght == 0){
			                        $scope.ngNotify.set('registro seleccionado no tiene registros','warn');

			                    }else{
			                        
			                        $scope.detailsRoles.data = dataReturn.data.product;
			                        $scope.Detailproduct = dataReturn.data.dataObject;
			                        $scope.grid=true
			                        console.log('details Roles',dataReturn.data);
			                    }
			                }, (err) => {
			                    $scope.ngNotify.set('No se ha podido conectar con el servicio','error');
			                })


	            }




             $scope.save=function(){
                 $scope.isDisabled=true
               	var module=$scope.module;
               	var product=$scope.product;

               	if(typeof module!=='undefined' && typeof product!=='undefined'){

                    var param={name:module,productName:product,user_id:$scope.USER_ID}

                            modulePermissionSrv.services.insertModuleByProductName(param).$promise.then((dataReturn) => {
                                $scope.isDisabled=false
			                    if(dataReturn.data.lenght == 0){
			                        $scope.ngNotify.set('registro seleccionado no tiene registros','warn');
			                    }else{
			                    	 int();
			                    	 $scope.ngNotify.set('registrarse se guarda','success');

			                    }
			                }, (err) => {
			                    $scope.ngNotify.set('No se ha podido conectar con el servicio','error');
			                })

                }
               }

               $scope.selectChanged=function(){
	               	if($scope.productName!='None'){
	                   $scope.product=$scope.productName
	               	}
                }

                $scope.selectAllItems=function(product_name,moduleName,id){
	               console.log(grid)
                }



    }


}// fin function principal
modulesListController.$inject=['$scope', 'groupsServices','$resource', '$mdDialog','$timeout','ngNotify','UserInfoConstant','$state','$modal','$location','LOCAL_ENV_CONSTANT','modulePermissionSrv']








// WEBPACK FOOTER //
// ./src/app/admin-panel/permissions/modules/modulesListController.js